<div style="text-align: center; padding:25px; position: absolute; top: 46%; z-index: 999; left: 46%;"
     *ngIf="map_loading">
  <i class="fa fa-pulse fa-spinner fa-4x" style="color: black;"></i>
</div>
<div id="mapDiv">
  <div *ngIf="item | async  as i" class="panel panel-default" id="mainForm"
       style="min-width: 375px; display: flex;">
    <div class="panel-body" style="width: 100%">
      <div style="position: absolute; top: -1px; left: 4px;">
        <app-help-docs-links recordType="view site info" color="#000"></app-help-docs-links>
      </div>
      <div *ngIf="viewMode"
           style="position: absolute; right: -74px; display: flex; flex-direction: column;">

        <button type="button" class="btn btn-default" id="cancelButton" (click)="cancel(i)">Cancel
        </button>
        <button type="button" class="btn btn-primary" id="saveButton" style="margin-top: 5px;"
                (click)="save(i) && i.meta.permissions.write">Save
        </button>

      </div>
      <div [ngStyle]="historyService.isVisible ? {'width': '700px'} : {'width': '450px'}"
           *ngIf="viewMode" class="row">
        <div class="col-md-12">
          <div class="row" *ngIf="historyService.isVisible" style="padding-bottom: 5px">
            <div class="col-md-5 offset-7" style="text-align: center;">
              <i role="button"
                 (click)="historyService.index > 0 ? historyService.index = historyService.index - 1 : historyService.index = historyService.index"
                 class="pull-left fa fa-arrow-circle-left fa-2 disabled" style="padding-top:3px;"
                 [ngStyle]="historyService.index === 0 ? {'color':'#AAA', 'cursor':'not-allowed'} : {'cursor':'pointer'}"></i>
              {{ historyService.data[historyService.index].last_edited_user }}
              on {{ historyService.data[historyService.index].from_date | date:'short' }}
              <i role="button"
                 (click)="historyService.index < historyService.data.length-1 ? historyService.index = historyService.index + 1 : historyService.index = historyService.index"
                 class="pull-right fa fa-arrow-circle-right fa-2"
                 style="padding-top: 3px;" disabled="historyService.index === historyService.data.length-1"
                 [ngStyle]="historyService.index === historyService.data.length-1 ? {'color':'#AAA', 'cursor':'not-allowed'} : {'cursor':'pointer'}"></i>
            </div>
          </div>
          <div class="row form-group" style="padding-top: 5px;">
            <div class="col-md-3" [ngClass]="i.meta.fields.name.hasError ? 'has-error' : ''">
              <label for="name">
                {{ i.meta.fields.name.label }}
                <span *ngIf="i.meta.fields.name.required">*</span>
              </label>
            </div>
            <div [ngClass]="{'has-error': i.meta.fields.name.hasError,
                             'col-md-9': !historyService.isVisible,
                             'col-md-6' : historyService.isVisible}">
              <input type="text" class="form-control" *ngIf="!useGeocoder"
                     [(ngModel)]="i.result.name" name="name"
                     [required]="i.meta.fields.name.required"/>

              <input class="form-control" type="text" [(ngModel)]="i.result.name" *ngIf="useGeocoder"
                     placeholder="" name="name" [resultFormatter]="nameLookupFormatter"
                     [inputFormatter]="nameLookupFormatter" container="body"
                     [ngbTypeahead]="nameSearch" (selectItem)="selectName(i, $event)">
              <span *ngIf="isNameLoading" style="position: absolute"><i class="fa fa-spinner fa-pulse"></i></span>
              <span *ngIf="noNameResults" style="position: absolute"><i
                  class="fa fa-times"></i> No matches found.</span>
            </div>
            <div *ngIf="historyService.isVisible" class="col-md-3">
              <app-display-field [value]="historyService.data[historyService.index]['name']"
                                 [type]="i.meta.fields['name'].type" [allowLong]="false"
                                 [choices]="i.meta.fields['name'].choices"></app-display-field>
            </div>
          </div>
          <div class="row form-group" *ngIf="i.meta.fields.site_id">
            <div class="col-md-3" [ngClass]="i.meta.fields.site_id.hasError ? 'has-error' : ''">
              <label for="site_id">
                {{ i.meta.fields.site_id.label }}
                <span *ngIf="i.meta.fields.site_id.required">*</span>
              </label>
            </div>
            <div [ngClass]="{'has-error': i.meta.fields.site_id.hasError,
                             'col-md-9': !historyService.isVisible,
                             'col-md-6' : historyService.isVisible}">
              <input type="text" class="form-control" name="site_id"
                     [(ngModel)]="i.result.site_id" placeholder="{{ i.meta.fields.site_id.help_text }}"
                     [required]="i.meta.fields.site_id.required"/>
            </div>

            <div *ngIf="historyService.isVisible" class="col-md-3">
              <app-display-field [value]="historyService.data[historyService.index]['site_id']"
                                 [type]="i.meta.fields['site_id'].type"
                                 [choices]="i.meta.fields['site_id'].choices"></app-display-field>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-3" [ngClass]="i.meta.fields.classification.hasError ? 'has-error' : ''">
              <label for="classification">
                {{ i.meta.fields.classification.label }}
                <span *ngIf="i.meta.fields.classification.required">*</span>
              </label>
            </div>
            <div [ngClass]="{'has-error': i.meta.fields.classification.hasError,
                             'col-md-9': !historyService.isVisible,
                             'col-md-6' : historyService.isVisible}">
              <select class="form-control" name="classification"
                      [(ngModel)]="i.result.classification"
                      [required]="i.meta.fields.classification.required">
                <option *ngFor="let choice of i.meta.fields.classification.choices" [value]="choice.value">
                  {{ choice.display_name }}
                </option>
              </select>
            </div>

            <div *ngIf="historyService.isVisible" class="col-md-3">
              <app-display-field [value]="historyService.data[historyService.index]['classification']"
                                 [type]="i.meta.fields['classification'].type"
                                 [choices]="i.meta.fields['classification'].choices"></app-display-field>
            </div>
          </div>
          <div class="row form-group" *ngIf="i.meta.fields.parcel_id">
            <div class="col-md-3" [ngClass]="i.meta.fields.parcel_id.hasError ? 'has-error' : ''">
              <label for="parcel_id">
                {{ i.meta.fields.parcel_id.label }}
                <span *ngIf="i.meta.fields.parcel_id.required">*</span>
              </label>
            </div>
            <div [ngClass]="{'has-error': i.meta.fields.parcel_id.hasError,
                             'col-md-9': !historyService.isVisible,
                             'col-md-6' : historyService.isVisible}">
              <input class="form-control" type="text" [(ngModel)]="i.result.parcel_id" placeholder="Search for parcel"
                     [ngbTypeahead]="parcelSearch" (selectItem)="updateParcel(i, $event)" container="body"
                     [resultFormatter]="parcelLookupFormatter" [inputFormatter]="parcelLookupFormatter"/>
              <span *ngIf="lotIsLoading" style="position: absolute"><i class="fa fa-spinner fa-pulse"></i></span>
              <span *ngIf="noLotResults" style="position: absolute"><i class="fa fa-times"></i> No matches found.</span>
            </div>

            <div *ngIf="historyService.isVisible" class="col-md-3">
              <app-display-field [value]="historyService.data[historyService.index]['parcel_id']"
                                 [type]="i.meta.fields['parcel_id'].type"
                                 [choices]="i.meta.fields['parcel_id'].choices"></app-display-field>
            </div>
          </div>
          <div class="row form-group" *ngIf="i.meta.fields.supplemental_location">
            <div class="col-md-3" [ngClass]="i.meta.fields.supplemental_location.hasError ? 'has-error' : ''">
              <label for="supplemental_location">
                {{ i.meta.fields.supplemental_location.label }}
                <span *ngIf="i.meta.fields.supplemental_location.required">*</span>
              </label>
            </div>
            <div [ngClass]="{'has-error': i.meta.fields.supplemental_location.hasError,
                             'col-md-9': !historyService.isVisible,
                             'col-md-6' : historyService.isVisible}">
              <input type="text" class="form-control" name="supplemental_location"
                     [(ngModel)]="i.result.supplemental_location"
                     placeholder="{{ i.meta.fields.supplemental_location.help_text }}"
                     [required]="i.meta.fields.supplemental_location.required"/>
            </div>

            <div *ngIf="historyService.isVisible" class="col-md-3">
              <app-display-field [value]="historyService.data[historyService.index]['supplemental_location']"
                                 [type]="i.meta.fields['supplemental_location'].type"
                                 [choices]="i.meta.fields['supplemental_location'].choices"></app-display-field>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-3" [ngClass]="i.meta.fields.streetaddress.hasError ? 'has-error' : ''">
              <label for="streetaddress">
                {{ i.meta.fields.streetaddress.label }}
                <span *ngIf="i.meta.fields.streetaddress.required">*</span>
              </label>
            </div>
            <div [ngClass]="{'has-error': i.meta.fields.streetaddress.hasError,
                             'col-md-9': !historyService.isVisible,
                             'col-md-6' : historyService.isVisible}">
              <input type="text" class="form-control" name="streetaddress" *ngIf="!useGeocoder"
                     [(ngModel)]="i.result.streetaddress" placeholder="{{ i.meta.fields.streetaddress.help_text }}"
                     [required]="i.meta.fields.streetaddress.required"/>
              <input class="form-control" type="text" [(ngModel)]="i.result.streetaddress" *ngIf="useGeocoder"
                     placeholder="Search for street address" name="streetaddress" [resultFormatter]="addressFormatter"
                     [inputFormatter]="addressInputFormatter" (selectItem)="selectAddress(i, $event)"
                     [ngbTypeahead]="findAddress" container="body">
              <span *ngIf="isAddressLoading" style="position: absolute"><i class="fa fa-spinner fa-pulse"></i></span>
              <span *ngIf="noAddressResults" style="position: absolute"><i
                  class="fa fa-times"></i> No matches found.</span>
            </div>

            <div *ngIf="historyService.isVisible" class="col-md-3">
              <app-display-field [value]="historyService.data[historyService.index]['streetaddress']"
                                 [type]="i.meta.fields['streetaddress'].type"
                                 [choices]="i.meta.fields['streetaddress'].choices"></app-display-field>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-3" [ngClass]="i.meta.fields.village.hasError ? 'has-error' : ''">
              <label for="village">
                {{ i.meta.fields.village.label }}
                <span *ngIf="i.meta.fields.village.required">*</span>
              </label>
            </div>
            <div [ngClass]="{'has-error': i.meta.fields.village.hasError,
                             'col-md-9': !historyService.isVisible,
                             'col-md-6' : historyService.isVisible}">
              <select class="form-control" name="village"
                      [(ngModel)]="i.result.village"
                      [required]="i.meta.fields.village.required">
                <option *ngFor="let choice of i.meta.fields.village.choices" [value]="choice.value">
                  {{ choice.display_name }}
                </option>
              </select>
            </div>

            <div *ngIf="historyService.isVisible" class="col-md-3">
              <app-display-field [value]="historyService.data[historyService.index]['village']"
                                 [type]="i.meta.fields['village'].type"
                                 [choices]="i.meta.fields['village'].choices"></app-display-field>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-3">
              <label for="latitude_input">Latitude:</label>
            </div>
            <div [ngClass]="{'has-error': i.meta.fields.shape.hasError,
                             'col-md-9': !historyService.isVisible,
                             'col-md-6' : historyService.isVisible}">
              <input type="text" class="form-control" id="latitude_input"
                     [(ngModel)]="coordinates.latitude" name="latitude">
            </div>
            <div *ngIf="historyService.isVisible" class="col-md-3">
              {{ historyService.data[historyService.index].json_coordinates.y }}
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-3">
              <label for="longitude_input">Longitude:</label>
            </div>
            <div [ngClass]="{'has-error': i.meta.fields.shape.hasError,
                             'col-md-9': !historyService.isVisible,
                             'col-md-6' : historyService.isVisible}">
              <input type="text" class="form-control" id="longitude_input"
                     [(ngModel)]="coordinates.longitude" name="longitude">
            </div>
            <div *ngIf="historyService.isVisible" class="col-md-3">
              {{ historyService.data[historyService.index].json_coordinates.x }}
            </div>
          </div>


          <div class="row form-group">
            <div class="col-md-3" [ngClass]="i.meta.fields.horizontal_collection_method.hasError ? 'has-error' : ''">
              <label for="horizontal_collection_method">
                {{ i.meta.fields.horizontal_collection_method.label }}
                <span *ngIf="i.meta.fields.horizontal_collection_method.required">*</span>
              </label>
            </div>
            <div [ngClass]="{'has-error': i.meta.fields.horizontal_collection_method.hasError,
                             'col-md-9': !historyService.isVisible,
                             'col-md-6' : historyService.isVisible}">
              <select class="form-control" name="horizontal_collection_method"
                      [(ngModel)]="i.result.horizontal_collection_method"
                      [required]="i.meta.fields.horizontal_collection_method.required">
                <option *ngFor="let choice of i.meta.fields.horizontal_collection_method.choices"
                        [value]="choice.value">{{ choice.display_name }}
                </option>
              </select>
            </div>
            <div *ngIf="historyService.isVisible" class="col-md-3">
              <app-display-field [value]="historyService.data[historyService.index].horizontal_collection_method"
                                 [type]="i.meta.fields.horizontal_collection_method.type"
                                 [choices]="i.meta.fields.horizontal_collection_method.choices"></app-display-field>
            </div>
          </div>


          <div class="row">
            <div class="col-md-9" *ngIf="i.result.last_edited_user !== undefined">
              Last edited by {{ i.result.last_edited_user }} on {{ i.result.last_edited_date | date:'short' }}
            </div>
            <div class="col-md-3" style="margin-top:-5px;">
              <div style="cursor: pointer;" class="pull-right"
                   (click)="historyService.getHistory(i.result, 'sites')"
                   *ngIf="i.result.globalid !== undefined">
                <div role="button" *ngIf="!historyService.isVisible" style="white-space: nowrap">Show History
                  <i
                      class="fa fa-chevron-right fa-1"
                      style="padding-top: 3px;"></i>
                </div>
                <div role="button" *ngIf="historyService.isVisible" style="white-space: nowrap">Hide History
                  <i
                      class="fa fa-chevron-left fa-1"
                      style="padding-top: 3px;"></i>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

      <div style="padding: 10px;" *ngIf="!viewMode && !loading">
        <div (click)="detailsCollapse.toggle()">
          <h4 style="margin-left: -5px; cursor: pointer; margin-bottom: 0;" *ngIf="detailsCollapsed">
            <i class="fa fa-chevron-down"></i><app-display-field [value]="i.result.name" type="string"></app-display-field></h4>
        </div>
        <div #detailsCollapse="ngbCollapse" [(ngbCollapse)]="detailsCollapsed">
          <h4 style="margin-left: -5px; cursor: pointer" (click)="detailsCollapse.toggle()" *ngIf="!detailsCollapsed">
            <i class="fa fa-chevron-up"></i>
            <app-display-field [value]="i.result.name" type="string"></app-display-field>
          </h4>
          <div class="row" style="padding: 0 10px; justify-content: space-between">
            <div>

              <h5 *ngIf="i.result.site_id">WALTERS ID: {{ i.result.site_id }}
                <i style="cursor:pointer;" (click)="copyToClipboard(host_no_port+i.result.site_id)"
                   ngbTooltip="Copy short url to clipboard" placement="right"
                   container="body" class="fa fa-copy"></i>
              </h5>
              <h5 *ngIf="i.result.parcel_id">Lot #: {{ i.result.parcel_id }}</h5>
              <span *ngIf="i.result.streetaddress">{{ i.result.streetaddress }}<br/></span>
              <span *ngIf="i.result.village">{{ i.result.village | display:i.meta.fields.village.choices }}<br/></span>
            </div>
            <div style="max-width: 150px;">
              <div class="span12">Latitude: {{ coordinates.latitude }}</div>
              <div class="span12">Longitude: {{ coordinates.longitude }}</div>
              <span>{{ i.result.classification | display:i.meta.fields.classification.choices }}</span>
            </div>
          </div>
          <div class="row" style="justify-content: space-between; margin: 5px 0 5px 0;">
            <app-status-input *ngIf="showStatusInput && !loading" [viewMode]="viewMode" [id]="i.result.globalid"
                              style="display: flex;"></app-status-input>
            <div class="col-md-2" *ngIf="i.meta.permissions.write">
              <button type="button" class="btn btn-primary pull-right" id="editButton"
                      (click)="edit(i)">Edit
              </button>
            </div>
          </div>
<!--          <div class="row">-->
<!--            <div class="col-md-12 text-center btn" style="margin-bottom: -12px;" (click)="scrollToRelated()">-->
<!--              <i class="fa fa-chevron-down"></i>-->
<!--              View related records-->
<!--              <i class="fa fa-chevron-down"></i></div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <!-- /.col-lg-12 -->
  </div>
  <div id="zoomToolbar" class="btn-toolbar">
    <div class="btn-group">
      <button id="zoomIn-button" class="btn btn-primary" (click)="zoomIn()">
        <span class="fa fa-plus"></span>
      </button>
      <button id="zoomOut-button" class="btn btn-primary" (click)="zoomOut()">
        <i class="fa fa-minus"></i>
      </button>
      <button *ngIf="item | async as i" id="lock-button" class="btn btn-primary" (click)="toggleMapLock(i)"
              ngbTooltip="Map {{map_locked ? 'locked' : 'unlocked'}} - click to {{map_locked ? 'unlock' : 'lock'}}."
              container="body" placement="top">
        <i *ngIf="map_locked" class="fa fa-lock"></i>
        <i *ngIf="!map_locked" class="fa fa-unlock"></i>
      </button>
    </div>
  </div>

  <button id="LayersButton" class="btn btn-primary"
          (click)="isCollapsed = !isCollapsed" ngbTooltip="Click to toggle layer menu" container="body"
          placement="left">
    Layers
  </button>
  <div id="Layers" style="height:725px;" [ngbCollapse]="isCollapsed">
    <div class="panel panel-default" style="text-align: center">
      <div class="panel-body" style="text-align: left;">
        <div id="layerList"></div>
      </div>
    </div>
  </div>
</div>
